import { Box, styled } from '@mui/material';

const InputGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
  },

  [theme.breakpoints.up('xl')]: {
    gridTemplateColumns: 'repeat(auto-fill,  minmax(300px, 1fr))',
  },
}));

export default InputGrid;
